import { render, staticRenderFns } from "./FavoriteCars.vue?vue&type=template&id=43a3a944&"
import script from "./FavoriteCars.vue?vue&type=script&lang=js&"
export * from "./FavoriteCars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports